import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const BannersSignsAndPosters = () => {

  const servicesFaqData = [
    { 
        question: "What customization options are available for banners, signs, and posters?", 
        answer: "Printingy offers extensive customization options for Banners, Signs, & Posters Prints, including sizes, materials, and finishes. Our flex printing banner design services allow you to create bold and eye-catching visuals, while our Poster Printing Personalized services ensure unique designs tailored to your branding. Additional options like lamination, grommets, and UV coatings enhance durability and visual appeal."
    },
    { 
        question: "Does Printingy handle bulk orders for banners, signs, and posters?", 
        answer: "Yes, Printingy specializes in bulk Banners, Signs, & Posters Prints, catering to businesses, events, and promotional campaigns. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for large-scale branding and advertising needs. Our efficient production processes guarantee reliable and timely delivery for all bulk orders."
    },
    { 
        question: "What industries benefit from banner, sign, and poster printing services?", 
        answer: "Our Banners, Signs, and poster Printing services cater to retail, hospitality, events, and corporate marketing industries. Businesses use custom banner printing and design for advertising and signage, while event organizers rely on our Poster Printing Personalized services for unique campaigns. Printingy provides tailored solutions to meet the specific needs of each sector."
    },
    { 
        question: "What materials and finishes are available for banners, signs, and posters?", 
        answer: "We use high-quality materials for Banners, Signs, & Posters Prints, including vinyl, fabric, and eco-friendly options. Finishes such as matte, glossy, and UV coating enhance durability and aesthetic appeal. These materials ensure your banners, signs, and posters maintain a professional appearance indoors and outdoors."
    },
    { 
        question: "Does Printingy provide design assistance for banners, signs, and posters?", 
        answer: "Yes, our custom banner printing and design services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to create visually engaging and functional layouts. From bold colours to impactful messaging, we ensure your banners, signs, and posters align with your goals."
    },
    { 
        question: "What is the typical turnaround time for printing banners, signs, and posters?", 
        answer: "Turnaround times for Banners, Signs, & Posters Prints depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customized designs or larger volumes, we provide clear timelines and prioritize meeting your deadlines without compromising quality."
    },
    { 
        question: "Are eco-friendly options available for banners, signs, and poster printing?", 
        answer: "Printingy is committed to sustainability and offers eco-friendly options for flex printing banner design and related services. To minimise environmental impact, we use recyclable materials, non-toxic inks, and sustainable production methods. These options are ideal for businesses seeking environmentally responsible printing solutions."
    },
    { 
        question: "What factors should I consider when ordering banners, signs, and posters?", 
        answer: "Consider the purpose, placement, and target audience when ordering Banners, Signs, & Posters Prints. Choosing the right material, size, and design elements ensures your prints are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your marketing goals."
    },
    { 
        question: "How do I order banners, signs, and poster printing?", 
        answer: "Placing an order is simple and efficient. Visit our website and select your preferences for Banners, Signs, & Posters Prints, including customization options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
    },
    { 
        question: "What makes bulk printing of banners, signs, and posters cost-effective?", 
        answer: "Bulk printing reduces per-unit costs, making it an economical choice for large-scale projects. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk Banners, Signs, and poster Printing services ensure exceptional value while maintaining professional standards."
    }
  ];
 const [pageTitle, setPageTitle] = useState('Ace Prints');  // Dynamic title state
 
   useEffect(() => {
     document.title = pageTitle; // Set the document title dynamically
   }, [pageTitle]); // This will run whenever the pageTitle changes
 

  return (
    <div>
       <MetaManager 
  title="Custom Banners, Signs, and Posters Printing Services"
  description=" Professional banners, signs, and poster printing services. Bulk custom banner printing and design with personalized poster and flex banner solutions."
  keywords="Banners, Signs, & Posters Prints,
Flex printing banner design,
Poster Printing Personalized,
Banners and signs,
Custom Banners Printing and Design

"
/>
      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Banners, Signs, and Posters Printing</h1>
              <h2 className="text-muted">
              Professional flex printing banner design and personalized posters
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4  shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
          Banners, signs, and posters are essential for effective communication, branding, and promotions. Printingy offers premium-quality Banners, Signs, & Posters printing services tailored to your needs. Our offerings include flex printing banner design, personalized posters, and custom banner printing and design solutions that leave a lasting impression.
          </p>
          
          <p>
          Our prints are vibrant, durable, and professional—perfect for retail promotions, corporate events, or personalized messaging. From sleek banners and signs to creative Poster Printing Personalized for unique branding, we deliver results that enhance visibility and engage your audience.
          </p>
          <p>With bulk printing options and advanced printing technology, Printingy ensures high-quality and cost-effective solutions for all your banner, sign, and poster needs. Trust us to bring your designs to life with precision and creativity.

          </p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Banner, Sign, and Poster Printing </h2>
                <h3 className="large-hed">High-quality, affordable, and customized printing solutions</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional flex printing banner design for impactful visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Custom Banners and signs tailored to your branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Personalized Poster Printing Personalized for unique messaging.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom banner printing and design for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials and weather-resistant options for indoor and outdoor use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for sharp details and vibrant colours.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and non-toxic inks for sustainable printing.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/bannersign.jpg" // Path relative to the public folder
                  alt="Flex printing banner design solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Banners, Signs, and Posters Delivered On Time</h2>
            <h3 className="small-hed">Focus on your promotions while we handle your banner printing needs</h3>
            <p>At Printingy, we combine advanced technology with expert craftsmanship to deliver exceptional Banners, Signs, & Posters Prints services. Whether you need custom banner printing and design for events or Poster Printing Personalized for unique campaigns, we ensure precision and consistency in every print.</p>
            <p>Our streamlined processes and commitment to quality guarantee timely delivery, even for bulk orders. Partner with Printingy for professional banners, signs, and posters that elevate your brand and captivate your audience.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default BannersSignsAndPosters;
